/**
 * Logger utility
 */

const isDev = process.env.NODE_ENV !== 'production';

export const log = (...args: any[]) => {
    // Info level - usually want this in production too for important system events
    console.log(...args);
};

export const debug = (...args: any[]) => {
    if (isDev) console.debug(...args);
};

export const info = (...args: any[]) => {
    console.info(...args);
};

export const warn = (...args: any[]) => {
    console.warn(...args);
};

export const error = (...args: any[]) => {
    console.error('[ERROR]', ...args);
};

// Named export for convenience
export const logger = {
    log,
    debug,
    info,
    warn,
    error,
};
